import { demoTradingHalt } from "./demo-trading-halt";

export const paymentProviderQuery = {
  read(_: any) {
    return demoTradingHalt;
  },
};

export const currentTradingHaltQuery = {
  read(_: any) {
    return null;
  },
};
